var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#222",
    rx: 2,
    height: 16,
    width: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.648 4.232a1 1 0 01.128 1.408l-5 6a1 1 0 01-1.505.036l-3-3.273a1 1 0 111.474-1.351L6.972 9.48 11.24 4.36a1 1 0 011.408-.128z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};

export default SvgCheckbox;